export default abstract class ApiAdapterBase {
    protected handleError(response: Response) {
        if (response.ok === false) {
            alert("Hiba történt");
            throw new Error();
        }
    }
}